import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-blocked-accounts-card',
    templateUrl: './blocked-accounts-card.component.html',
    styleUrls: ['./blocked-accounts-card.component.scss'],
})
export class BlockedAccountsCardComponent implements OnInit {
    public tenant_id = this.route.snapshot.paramMap.get('tenant');

    constructor(
        public router: Router,
        private route: ActivatedRoute,
    ) {}

    ngOnInit(): void {}

    navigate() {
        this.router.navigate([`client/${this.tenant_id}/hardening/blocked_accounts`]);
    }
}
